import "./Leads.css";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { useState, useEffect } from "react";
import GetAllLeadsFromDeals from "../../Controller/getClients";
import NoDataFound from "../../../../components/Common/NoDataFound/NoDataFound";
const Leads = ({
  leads,
  setLeads,
  leadsError,
  setLeadsError,
  campaignSource,
}) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = useState("*");
  const [searchInput, setSearchInput] = useState("");
  const [localAllLeads, setLocalAllLeads] = useState([]);
  const [localLeadsState, setLocalLeadsState] = useState([]);
  const [displayMessage, setdisplayMessage] = useState("");
  const [isNoData, setIsNoData] = useState(false);

  useEffect(async () => {
    setOpenFilter(false);
    let tempLeads = await GetAllLeadsFromDeals(filter);
    setLocalAllLeads(tempLeads);
  }, [filter]);
  useEffect(() => {
    let tempLeads = [];
    for (let i = 0; i < leads.length; i++) {
      tempLeads.push(leads[i].id);
    }
    if (leads.length < 0) {
      setIsNoData(true);
    }
    setLocalLeadsState(tempLeads);
  }, [leads]);
  useEffect(() => {}, [localLeadsState]);
  const setLead = (data) => {
    if (data.email) {
      let tempLeads = localLeadsState;
      if (tempLeads.includes(data.id)) {
        const index = tempLeads.indexOf(data.id);
        tempLeads.splice(index, 1);
        setLocalLeadsState(tempLeads);
        let tempLeads2 = leads;
        tempLeads2.splice(index, 1);
        setLeads(tempLeads2);

        return false;
      } else {
        let tempLeads = localLeadsState;
        tempLeads.push(data.id);
        setLocalLeadsState(tempLeads);
        let tempLeads2 = leads;
        tempLeads2.push({ ...data });
        setLeads(tempLeads2);

        return true;
      }
    } else {
      return false;
    }
  };

  const isDisabled = (email, phone) => {
    if (campaignSource === "Email") {
      if (email === null) {
        return true;
      } else {
        return false;
      }
    } else {
      if (phone === "") {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div className="marketing-lead">
      <div className="marketing-input-main">
        <div className="input-group marketing-search-bar">
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            className="marketing-search-icon"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
              fill="#929292"
            />
          </svg>
          <input
            type="search"
            className="leads-search-input"
            placeholder="Search client name here"
            disabled={localAllLeads?.length == 0}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
          />
        </div>
        <div>
          <FilterListRoundedIcon
            onClick={() => setOpenFilter(!openFilter)}
            style={{
              height: 38,
              width: 38,
              color: "gray",
              border: "1px solid lightgray",
              borderRadius: "5px",
              marginLeft: "5px",
              backgroundColor: "transparent",
            }}
          />
          {openFilter && (
            <div className="marketing-custom-popup-model">
              <button
                className={`marketing-custom-filter-btn ${
                  filter === "*" && "marketing-custom-filter-btn-active"
                }`}
                onClick={() => setFilter("*")}
              >
                All
              </button>
              <button
                className={`marketing-custom-filter-btn ${
                  filter === "open" && "marketing-custom-filter-btn-active"
                }`}
                onClick={() => setFilter("open")}
              >
                Open
              </button>
              <button
                className={`marketing-custom-filter-btn ${
                  filter === "won" && "marketing-custom-filter-btn-active"
                }`}
                onClick={() => setFilter("won")}
              >
                Won
              </button>
              <button
                className={`marketing-custom-filter-btn ${
                  filter === "lost" && "marketing-custom-filter-btn-active"
                }`}
                onClick={() => setFilter("lost")}
              >
                Lost
              </button>
              <button
                className={`marketing-custom-filter-btn ${
                  filter === "auto lost" && "marketing-custom-filter-btn-active"
                }`}
                onClick={() => setFilter("auto lost")}
              >
                Archived
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="select-all-element">
        <div>
          <input
            type="checkbox"
            disabled={
              localAllLeads?.length == 0 ||
              (localAllLeads.length !== localLeadsState.length &&
                localLeadsState.length > 0)
                ? true
                : false
            }
            onClick={() => {
              localAllLeads.map((data, index) => {
                setLead(data);
              });
              if (localLeadsState.length <= 0) {
                setdisplayMessage("Select at least one client ");
                setLeadsError(true);
              } else if (localLeadsState.length === 1) {
                setdisplayMessage("1 client is selected");
                setLeadsError(false);
              } else if (localLeadsState.length >= 0) {
                setLeadsError(false);

                setdisplayMessage(
                  localLeadsState?.length.toString() + " clients are selected"
                );
              }
            }}
            checked={
              localAllLeads.length === localLeadsState.length ? true : false
            }
          />

          <label className="marketing-client-header-lbl"> Select All</label>
        </div>
        {leadsError ? (
          <label className="custom-error-message" htmlFor="text">
            {displayMessage}
          </label>
        ) : (
          localLeadsState?.length >= 1 && (
            <label className="custom-label" htmlFor="text">
              {displayMessage}
            </label>
          )
        )}
      </div>

      <div className="marketing-leads-body">
        {localAllLeads?.length > 0 ? (
          localAllLeads
            .filter((el) => {
              if (searchInput === "") {
                return el;
              } else {
                return el.name.toLowerCase().includes(searchInput);
              }
            })
            .map((data, index) => {
              let isChecked;
              isChecked = localLeadsState.includes(data.id);
              if (data.name) {
                return (
                  <div className="marketing-client-comp">
                    <div className="marketing-client-body">
                      <div>
                        {/* <CustomCheckBox /> */}
                        <input
                          disabled={data?.email ? false : true}
                          type="checkbox"
                          onClick={() => {
                            isChecked = setLead(data);
                            if (localLeadsState.length <= 0) {
                              setdisplayMessage("Select at least one client ");
                              setLeadsError(true);
                            } else if (localLeadsState.length === 1) {
                              setdisplayMessage("1 client is selected");
                              setLeadsError(false);
                            } else if (localLeadsState.length >= 0) {
                              setLeadsError(false);

                              setdisplayMessage(
                                localLeadsState?.length.toString() +
                                  " clients are selected"
                              );
                            }
                          }}
                          checked={isChecked}
                        />
                        <label className="marketing-client-header-lbl">
                          {data.name}
                        </label>
                      </div>
                      <div
                        className={`marketing-client-status-lbl py-1 px-3 ${
                          data.currentstatus === "won"
                            ? "marketing-client-status-lbl-won"
                            : data.currentstatus === "lost"
                            ? "marketing-client-status-lbl-lost"
                            : data.currentstatus === "open"
                            ? "marketing-client-status-lbl-open"
                            : "marketing-client-status-lbl-archived"
                        }`}
                      >
                        {data.currentstatus}
                      </div>
                    </div>

                    <div className="marketing-client-body">
                      {data?.email ? (
                        <label className="marketing-client-email-lbl">
                          {data.email}
                        </label>
                      ) : (
                        <label className="marketing-client-email-lbl">
                          No Email
                        </label>
                      )}
                      {data?.phone ? (
                        <label className="marketing-client-pno-lbl">
                          {data.phone}
                        </label>
                      ) : (
                        <label className="marketing-client-pno-lbl">
                          No number
                        </label>
                      )}
                    </div>
                    {data.address && (
                      <label className="marketing-client-address-lbl">
                        {data.address}
                      </label>
                    )}
                  </div>
                );
              }
            })
        ) : (
          <div className="no-lead-found">
            <NoDataFound />
          </div>
        )}
      </div>
    </div>
  );
};

export default Leads;
